const defaultCrudConfig = {
    endpoint: 'concepts',
    primaryKey: 'codeId',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['codeId'],
            query: {
                filter: 'nodeId=#@nodeId@#',
                property: 'queryClass=PrimaryKey'
            }
        },
        fetchAllByCollection: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['partId'],
            query: {
                filter: 'partId=#@partId@#',
                property: 'queryClass=ByConceptCollection'
            }
        },
        fetchByConstraintTypeCode: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['codeId'],
            query: {
                filter: 'codeId=#@codeId@#',
                property: 'queryClass=PrimaryKey'
            }
        },
        fetchByConstraintTypeCodeSystem: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['codeSystemId'],
            query: {
                filter: 'codeSystemId=#@codeSystemId@#',
                property: 'queryClass=ByCodeSystemId'
            }
        },
        fetchByConstraintTypeConcept: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['conceptCodeId'],
            query: {
                filter: 'conceptCodeId=#@conceptCodeId@#',
                property: 'queryClass=ByConceptId'
            }
        },
        fetchByConstraintTypeValueSet: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['valueSetId'],
            query: {
                filter: 'valueSetId=#@valueSetId@#',
                property: 'queryClass=ByValueSetId'
            }
        },
        fetchByConstraintTypeList: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['listId'],
            query: {
                filter: 'listId=#@listId@#',
                property: 'queryClass=ByListId'
            }
        },
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['codeId', 'nodeDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'cds',
            args: ['codeId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds',
            args: ['codeDoc']
        }
    }
};

export default defaultCrudConfig;
